import React from "react";
import { gardienById } from "@/data/gardiens";
import { Reveal } from "@/components/Reveal";

// Petit badge « Gardien de cette page » : portrait, nom, valeur, citation.
export const GardienBadge = ({ gardienId, label = "Gardien de cette page" }) => {
  const g = gardienById(gardienId);
  if (!g) return null;
  return (
    <Reveal>
      <div className="flex items-center gap-5 bg-warm/10 border border-warm/25 rounded-3xl p-5 sm:p-6 max-w-2xl" data-testid={`gardien-badge-${g.id}`}>
        <img src={g.image} alt={`${g.name} — ${g.title}`} className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover object-top border-2 shrink-0" style={{ borderColor: `${g.color}55` }} />
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{label}</p>
          <p className="font-serif-display text-2xl mt-1">{g.name} <span className="text-sm text-muted-foreground font-sans">· {g.title}</span></p>
          <p className="text-xs uppercase tracking-[0.2em] mt-1" style={{ color: g.color }}>{g.value}</p>
          <p className="font-serif-display italic text-foreground/75 mt-2 leading-snug">« {g.quote} »</p>
        </div>
      </div>
    </Reveal>
  );
};
